<script>
import { transcodificableContents } from '../../config';
import HeaderVideoChip from './HeaderVideoChip';

export default {
  name: 'nx-content-editor-header-specific-chips',
  functional: true,
  props: {
    type: String,
    value: Object,
  },
  render(createElement, context) {
    const { type } = context.props;
    if (transcodificableContents.includes(type)) {
      // eslint-disable-next-line
      const transcoded = context.props.value.channels.master.transcoded;
      // eslint-disable-next-line
      const publishOnVideoTranscoded = context.props.value.publishOnVideoTranscoded;
      // if it is already transcoded we dont need any additional chip
      if (transcoded) {
        return null;
      }
      return createElement(HeaderVideoChip, { props: { publishOnVideoTranscoded } });
    }

    return null;
  },
};
</script>
